import { sentrySetup } from '@config/sentry';
import { useEffect } from 'react';

interface IssueTrackingProps {
  dsn: string;
}

export default function IssueTracking(props: IssueTrackingProps) {
  const { dsn } = props;

  useEffect(() => {
    sentrySetup.initialize(dsn);
  }, [dsn]);

  return null;
}
